import { getCompatConfig } from '../compat.js';

const useIsRevenueCatAvailable = () => getCompatConfig().PRICING.useIsRevenueCatAvailable();
const useQueryRevenueCatOffering = (offeringId) => getCompatConfig().PRICING.useQueryRevenueCatOffering(offeringId);
const useMutationPurchase = () => getCompatConfig().PRICING.useMutationPurchase();
const useSubscriptionAccess = () => getCompatConfig().PRICING.useSubscriptionAccess();
const useQueryPricingManagementUrl = (queryOptions) => getCompatConfig().PRICING.useQueryPricingManagementUrl(queryOptions);
const useMutationRevenueCatRestorePurchase = () => getCompatConfig().PRICING.useMutationRevenueCatRestorePurchase();

export { useIsRevenueCatAvailable, useMutationPurchase, useMutationRevenueCatRestorePurchase, useQueryPricingManagementUrl, useQueryRevenueCatOffering, useSubscriptionAccess };
//# sourceMappingURL=pricing.js.map
